/** @file mesh.setWeights: replaces every vertex's influences of a skinned mesh (normalized, cap 4). */
import { z } from 'zod';
import { defineCommand } from '../defineCommand';
import { editWeights } from './editWeights';
import { influencePair } from './influencePair';
import { resolveAllWeights } from './resolveAllWeights';

/** mesh.setWeights: weights[v] = [[bone, weight], …] for every vertex v; raw non-negative weights are fine. */
export const command = defineCommand({
  name: 'mesh.setWeights',
  description: "Replace every vertex's influences of a skinned mesh: weights[v] = [[bone, weight], …]; each list is merged, capped at 4, pruned below 0.005 and normalized to sum 1, and newly weighted bones bind at their setup world.",
  input: z.object({ target: z.string().min(1), weights: z.array(z.array(influencePair)) }).strict(),
  apply(draft, input, ctx) {
    editWeights(draft, ctx, input.target, (_g, mesh) => resolveAllWeights(ctx, mesh, input.weights));
  },
});
